import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-toastify';
import Popup, { PopupFooter } from '../common-components/pop-up/Popup';
import { Lightbulb } from 'lucide-react';
import CommonButton from '../common-components/button/CommonButton';
import CommonDropdown from '../common-components/dropdown/CommonDropdown';
import { useStore } from '../../hooks/useStore';
import { suggestionService } from '../../services/modules/suggestion/suggestion.service';
import styles from './SuggestionPopup.module.css';

const SUGGESTION_OPTIONS = [
  { value: 'öneri', label: 'Öneri' },
  { value: 'bug', label: 'Bug' },
];

const SuggestionPopup = () => {
  const { popupStore } = useStore();
  const [type, setType] = useState<string | null>(null);
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetForm = () => {
    popupStore.setIsSuggestionPopupOpen(false);
    setType(null);
    setMessage('');
  };

  const handleClose = () => {
    if (!isSubmitting) resetForm();
  };

  const handleSubmit = async () => {
    if (!type || !message.trim()) return;
    setIsSubmitting(true);
    try {
      const result = await suggestionService.sendSuggestion({
        type,
        message: message.trim(),
      });
      if (result?.error) {
        toast.error(result.message || 'Öneri gönderilirken bir hata oluştu.');
      } else {
        toast.success(result?.message || 'Öneriniz başarıyla gönderildi.');
        resetForm();
      }
    } catch (err: unknown) {
      const msg = (err as { message?: string })?.message || 'Öneri gönderilirken bir hata oluştu.';
      toast.error(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Popup
      isOpen={popupStore.isSuggestionPopupOpen}
      onClose={handleClose}
      title="Öneri Gönder"
      description="Öneri veya bug bildirimi gönderin"
      variant="info"
      icon={<Lightbulb size={22} strokeWidth={2} />}
      footer={
        <PopupFooter align="end">
          <CommonButton type="cancel" onClick={handleClose} disabled={isSubmitting}>
            İptal
          </CommonButton>
          <CommonButton
            type="primary"
            onClick={handleSubmit}
            disabled={!type || !message.trim() || isSubmitting}
          >
            {isSubmitting ? 'Gönderiliyor...' : 'Gönder'}
          </CommonButton>
        </PopupFooter>
      }
    >
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Tür</label>
        <CommonDropdown
          options={SUGGESTION_OPTIONS}
          value={type}
          onChange={value => setType(value)}
          placeholder="Seçiniz..."
        />
      </div>
      <div className={styles.formGroup}>
        <label className={styles.formLabel}>Açıklama</label>
        <textarea
          className={styles.formTextarea}
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="Önerinizi veya bildirdiğiniz hatayı detaylı şekilde yazınız..."
          rows={5}
        />
      </div>
    </Popup>
  );
};

export default observer(SuggestionPopup);
